import { render, staticRenderFns } from "./UpdateState.vue?vue&type=template&id=10468bc9&scoped=true&"
import script from "./UpdateState.vue?vue&type=script&lang=js&"
export * from "./UpdateState.vue?vue&type=script&lang=js&"
import style0 from "./UpdateState.vue?vue&type=style&index=0&id=10468bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10468bc9",
  null
  
)

export default component.exports
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QChip});
